import {
  type GridColDef,
  GridColumnMenu,
  type GridColumnMenuProps,
  GridColumnMenuHideItem,
  type ColumnMenuItemsConfig,
} from '@mui/x-data-grid-premium'
import { FilterDrawerItem } from './components/FilterDrawerItem/FilterDrawerItem'
import { SortItem } from './components/SortItem/SortItem'

interface ColumnMenuProps extends GridColumnMenuProps {
  itemsConfig: Maybe<ColumnMenuItemsConfig>
  onFilterClick: (colDef: GridColDef) => void
  onClearSort?: () => void
}

export const ColumnMenu: React.FC<ColumnMenuProps> = ({ itemsConfig, onFilterClick, onClearSort, ...props }) => {
  const { filter, hide } = itemsConfig ?? {}
  const showFilterItem = filter && (props.colDef.filterable === undefined || props.colDef.filterable)
  const showHideItem = hide && (props.colDef.hideable === undefined || props.colDef.hideable)

  return (
    <GridColumnMenu
      {...props}
      slots={{
        columnMenuSortItem: SortItem,
        columnMenuPinningItem: null,
        columnMenuAggregationItem: null,
        columnMenuGroupingItem: null,
        columnMenuColumnsItem: showHideItem ? GridColumnMenuHideItem : null,
        filterDrawerItem: showFilterItem ? FilterDrawerItem : null,
      }}
      slotProps={{
        columnMenuSortItem: {
          onClearSort,
        },
        filterDrawerItem: {
          onFilterClick,
        },
      }}
    />
  )
}
